import { render, staticRenderFns } from "./ArticleContainersGroup.vue?vue&type=template&id=24da83af&scoped=true"
import script from "./ArticleContainersGroup.vue?vue&type=script&lang=js"
export * from "./ArticleContainersGroup.vue?vue&type=script&lang=js"
import style0 from "./ArticleContainersGroup.vue?vue&type=style&index=0&id=24da83af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da83af",
  null
  
)

export default component.exports